/**
 * Vehicle Makes Data
 * Centralized data structure for vehicle makes used across the application
 */

export const vehicleMakes = [
  {
    name: 'Audi',
    slug: 'audi-car-finance',
    url: '/vehicles/audi-car-finance',
  },
  {
    name: 'BMW',
    slug: 'bmw',
    url: '/vehicles/bmw',
  },
  {
    name: 'Mercedes',
    slug: 'mercedes',
    url: '/vehicles/mercedes',
  },
  {
    name: 'Toyota',
    slug: 'toyota',
    url: '/vehicles/toyota',
  },
  {
    name: 'Volkswagen',
    slug: 'volkswagen',
    url: '/vehicles/volkswagen',
  },
  {
    name: 'Ford',
    slug: 'ford',
    url: '/vehicles/ford',
  },
  {
    name: 'Vauxhall',
    slug: 'vauxhall',
    url: '/vehicles/vauxhall',
  },
  {
    name: 'Honda',
    slug: 'honda',
    url: '/vehicles/honda',
  },
]

/**
 * Get vehicle make by slug
 * @param {string} slug - The vehicle slug
 * @returns {object|undefined} Vehicle make object or undefined if not found
 */
export const getVehicleBySlug = slug => {
  return vehicleMakes.find(vehicle => vehicle.slug === slug)
}

/**
 * Get vehicle make by name
 * @param {string} name - The vehicle name
 * @returns {object|undefined} Vehicle make object or undefined if not found
 */
export const getVehicleByName = name => {
  return vehicleMakes.find(
    vehicle => vehicle.name.toLowerCase() === name.toLowerCase()
  )
}

/**
 * Get all vehicle names
 * @returns {string[]} Array of vehicle names
 */
export const getVehicleNames = () => {
  return vehicleMakes.map(vehicle => vehicle.name)
}

/**
 * Get all vehicle URLs
 * @returns {string[]} Array of vehicle URLs
 */
export const getVehicleUrls = () => {
  return vehicleMakes.map(vehicle => vehicle.url)
}
